import { create } from 'zustand';

import { stateCreator } from './state';
import { TeamsStoreState } from './types';
export { teamsStoreSelector } from './selector';

export const useTeamsStore = create<TeamsStoreState>(stateCreator);

export * from './types';
